export enum SupportedLocales {
	en = "en",
	zh = "zh"
}
